import { recordsApi } from "shared/api/recordsApi";

export const clientDeleteEventRecordRequest = (recordId) => {
  return recordsApi.deleteEventRecord(recordId);
};
